var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasBalance)?_c('span',[_vm._v("Balance "+_vm._s(this.balanceLabel))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }